import { render, staticRenderFns } from "./duration-selector.vue?vue&type=template&id=1dd92bf4&scoped=true&"
import script from "./duration-selector.vue?vue&type=script&lang=js&"
export * from "./duration-selector.vue?vue&type=script&lang=js&"
import style0 from "./duration-selector.vue?vue&type=style&index=0&id=1dd92bf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd92bf4",
  null
  
)

export default component.exports